export const tableschema1 = {
    "name_table": "Розділ I. Кількість дітей у закладі на кінець звітного року",
    "titles": [
        "Усього у тому числі у віці",
        "до 1 року",
        "від 1 до 2 років",
        "від 2 до 3 років",
        "від 3 до 4 років",
        "від 4 до 5 років",
        "від 5 до 6 років",
        "від 6 до 7 років",
        "від 7 до 8 років",
        "дівчата",
        "діти-сироти та діти, позбавлені батьківського піклування",
        "діти з інвалідністю",
        "діти з особливими освітніми потребами",
        "діти, потерпілі від наслідків Чорнобильської катастрофи",
        "діти з числа внутрішньо переміщених осіб",
        "діти учасників бойових дій"
    ],
    "parts": [
        {
            "title": "Кількість дітей",
            "subtitle": "усього",
            "fields": [
                "CHwork10001",
                "CHwork11001",
                "CHwork12001",
                "CHwork13001",
                "CHwork14001",
                "CHwork601",
                "CHwork701",
                "CHwork801",
                "CHwork901",
                "",
                "CHwork15001",
                "CHwork16101",
                "CHwork16201",
                "CHwork17001",
                "CHwork18001",
                "CHwork19001"
            ]
        },
        {
            "title": "Кількість дітей",
            "subtitle": "з них дівчата",
            "fields": [
                "CHwork10002",
                "CHwork11002",
                "CHwork12002",
                "CHwork13002",
                "CHwork14002",
                "CHwork602",
                "CHwork702",
                "CHwork802",
                "CHwork902",
                "",
                "CHwork15002",
                "CHwork16102",
                "CHwork16202",
                "CHwork17002",
                "CHwork18002",
                "CHwork19002"
            ]
        },
        {
            "title": "За формами здобуття",
            "subtitle": "очна (денна)",
            "fields": [
                "CHwork100031",
                "CHwork110031",
                "CHwork120031",
                "CHwork130031",
                "CHwork140031",
                "CHwork603",
                "CHwork703",
                "CHwork803",
                "CHwork903",
                "CHwork1003",
                "CHwork150031",
                "CHwork161031",
                "CHwork162031",
                "CHwork170031",
                "CHwork180031",
                "CHwork190031"
            ]
        },
        {
            "title": "За формами здобуття",
            "subtitle": "мережева",
            "fields": [
                "CHwork10004",
                "CHwork11004",
                "CHwork12004",
                "CHwork13004",
                "CHwork14004",
                "CHwork604",
                "CHwork704",
                "CHwork804",
                "CHwork904",
                "CHwork1004",
                "CHwork15004",
                "CHwork16104",
                "CHwork16204",
                "CHwork17004",
                "CHwork18004",
                "CHwork19004"
            ]
        },
        {
            "title": "За формами здобуття",
            "subtitle": "дистанційна",
            "fields": [
                "CHwork10005",
                "CHwork11005",
                "CHwork12005",
                "CHwork13005",
                "CHwork14005",
                "CHwork605",
                "CHwork705",
                "CHwork805",
                "CHwork905",
                "CHwork1005",
                "CHwork15005",
                "CHwork16105",
                "CHwork16205",
                "CHwork17005",
                "CHwork18005",
                "CHwork19005"
            ]
        },
        {
            "title": "За формами здобуття",
            "subtitle": "пед. патронаж",
            "fields": [
                "CHwork10003",
                "CHwork11003",
                "CHwork12003",
                "CHwork13003",
                "CHwork14003",
                "CHwork606",
                "CHwork706",
                "CHwork806",
                "CHwork906",
                "CHwork1006",
                "CHwork15003",
                "CHwork16103",
                "CHwork16203",
                "CHwork17003",
                "CHwork18003",
                "CHwork19003"
            ]
        }
    ],
    "shorts": {
        "titles": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16"
        ],
        "parts": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6"
        ]
    }
};